import React, { Suspense, lazy } from "react";
import { ModalLoad } from "../Modals/Modals";
const Crash = lazy(() => import("../../pages/Crash/Crash"));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Suspense fallback={<ModalLoad />}>
          <Crash />
        </Suspense>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
